import { render, staticRenderFns } from "./PartnershipPane.vue?vue&type=template&id=9e132746&"
import script from "./PartnershipPane.vue?vue&type=script&lang=ts&"
export * from "./PartnershipPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e132746')) {
      api.createRecord('9e132746', component.options)
    } else {
      api.reload('9e132746', component.options)
    }
    module.hot.accept("./PartnershipPane.vue?vue&type=template&id=9e132746&", function () {
      api.rerender('9e132746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/PartnershipPane.vue"
export default component.exports